import React, { Component } from "react";
import {
  Form,
  FormGroup,
  FormControl,
  ControlLabel,
  Button, 
  Glyphicon, 
  Modal, 
  Tooltip, 
  OverlayTrigger,
  Col,
  ToggleButtonGroup,
  ToggleButton,
  Panel,
  Table
 } from "react-bootstrap";
import LoaderButton from "../../components/LoaderButton";
import { invokeApig } from "../../libs/awsLib";
import "./NewAlert.css";
import "../../react-select.min.css";
import Select from 'react-select';
import AlertScalation from './AlertScalation';

export class NewAlert extends Component {
  constructor(props) {
    super(props);

    this.handleShow = this.handleShow.bind(this);
    this.handleEdit = this.handleEdit.bind(this);
    this.handleClose = this.handleClose.bind(this);
    
    this.typeOptions = [
	  	{ id: 'UNIT', label: 'Vehículo(s)'},
      { id: 'TAG', label: 'Grupo de vehículos'},
      { id: 'ALL', label: 'Todos los vehículos'}
    ];
    
    this.alertOptions = [
	  	{ id: '', label: 'Selecciona...'},
	  	{ id: 'overspeed', label: 'Exceso de velocidad'},
      { id: 'engineon', label: 'Encendido de motor'},
      { id: 'engineoff', label: 'Apagado de motor'},
      { id: 'energydisconnected', label: 'Desconexión de corriente'},
      { id: 'lowbattery', label: 'Batería baja'},
      { id: 'minimundetention', label: 'Detención mínima'},
      { id: 'maximundetention', label: 'Detención máxima'},
      { id: 'entertozone', label: 'Entrada a zona'},
      { id: 'outofzone', label: 'Salida de zona'},
      { id: 'inzone', label: 'Estadía en zona'},
      { id: 'withoutauthorizationdrive', label: 'Conducción no autorizada'},
      { id: 'nosatelliteonsight', label: 'Sin satélites en vista'},
      { id: 'emergencybutton', label: 'Boton de emergencia'}
	  ];

    this.state = {
      isLoading: null,
      isEdit: props.alertId ? true : false,
      show: false,
      nameAlert:'',
      description:'',
      semaphore: '',
      type: '',
      escalations: [],
      showUnits: false,
      showTags: false,
      units: [],
      tags: [],
      removeSelected: true,
      disabled: false,
      stayOpen: false,
      value: [],
      options: this.typeOptions,
      alertOptions: this.alertOptions,
      alertScalations: []
    };
  }

  validateForm() {
	  return this.state.nameAlert.length > 0 && this.state.description.length > 0;
  }

  handleChange = event => {
    this.setState({
      [event.target.id]: event.target.value
    });
  }

  createAlert(alert) {
    return invokeApig({
      path: "/alert",
      method: "POST",
      body: alert
    });
  }

  updateAlert(alert) {
    return invokeApig({
      path: `/alert`,
      method: "PUT",
      body: alert
    });
  }

  getAlert() {
    return invokeApig({
      path: `/alert/${this.props.alertId}`
    });
  }

  handleClose() {
    this.setState({ show: false });
  }

  handleShow() {
    this.setState({ show: true });
  }

  handleEdit = async event =>{
    this.setState({ isLoading: true });
    event.preventDefault();
    try {
      const results = await this.getAlert();
      let alert = results[0];
      let alertScalations = [];
      if (alert && alert.escalations) {
        alert.escalations.forEach(escalation => {
          alertScalations.push({
            level: escalation.level,
            time: escalation.time,
            emails: escalation.emails,
            emailType: escalation.emailType,
            confirmed: true
          });
        });
      }
      let value = [];
      const options = [];
      this.setState({ options: [] });
      if (alert.type) {
        let type = this.typeOptions.find(type => {
          return type.id === alert.type;
        });
        value.push(type);
        if (alert.type === 'UNIT') {
          try {
            const result = await this.getUnits();
            if (result && result.Items) {
              result.Items.map((unit) => {
                let unitOption = {
                  id: unit.id,
                  label: unit.internalNumber
                };
                let unitSelected = false;
                alert.units.forEach(unitId => {
                  if (unit.id === unitId) {
                    value.push(unitOption);
                    unitSelected = true;
                    return;
                  }
                });
                if (!unitSelected) {
                  options.push(unitOption);
                }
                return null;
              });
            }
          } catch (e) {
            alert(e);
          }
        } else if (alert.type === 'TAG') {
          try {
            const result = await this.getTags();
            if (result && result.Items) {
              result.Items.map((tag) => {
                let tagOption = {
                  id: tag.tag,
                  label: tag.tag
                };
                let tagSelected = false;
                alert.tags.forEach(tagId => {
                  if (tag.tag === tagId) {
                    value.push(tagOption);
                    tagSelected = true;
                    return;
                  }
                });
                if (!tagSelected) {
                  options.push(tagOption);
                }
                return null;
              });
            }
          } catch (e) {
            alert(e);
          }
        }
      }
      this.setState({ ...alert, value, options, alertScalations, show: true });
    } catch (e) {
      this.props.onAlertError({ message: "Error al consultar datos de la Alerta!" });
    }
    this.setState({ isLoading: false });
  }

  handleSubmit = async event => {
    event.preventDefault();
    this.setState({ isLoading: true });
    try {
      if (this.state.isEdit) {
        await this.updateAlert({
          range: this.props.alertId,
          alert: this.state.alert,
          nameAlert: this.state.nameAlert,
          description: this.state.description,
          semaphore: this.state.semaphore,
          type: this.state.type,
          status: this.state.status,
          escalations: this.state.escalations,
          units: this.state.units,
          tags: this.state.tags
        });
        this.props.onAlertSuccess({ message: "Alerta actualizado exitosamente!" });
      } else {
        await this.createAlert({
          alert: this.state.alert,
          nameAlert: this.state.nameAlert,
          description: this.state.description,
          semaphore: this.state.semaphore,
          type: this.state.type,
          status: 'Activo',
          escalations: this.state.escalations,
          units: this.state.units,
          tags: this.state.tags
        });
        this.props.onAlertSuccess({ message: "Alerta ingresada exitosamente!", refresh: true });
      }
      this.handleClose();
    } catch (e) {
      this.props.onAlertError({ message: "Error al guardar Alerta! Por favor revise los datos e intente nuevamente." });
    }
    this.setState({ isLoading: false });
  }

  handleSelectSemaphoreChange = event => {
    this.setState({
      semaphore: event.target.value
    });
  }
  
  handleSemaphoreChange = value => {
    this.setState({ semaphore: value });
  }

  handleAlertChange = event => {
    this.setState({
      alert: event.target.value,
      nameAlert: event.target.options[event.target.selectedIndex].text
    });
  }
1
  getUnits() {
    return invokeApig({
      path: "/unit/find",
      method: "POST",
      body: {
        "page": 0,
        "size": 10
      }
    });
  }

  async showUnits() {
	  const options = [];
    try {
      this.setState({ options: [] });
      const result = await this.getUnits();
      if (result && result.Items) {
        result.Items.map((unit) => {
          options.push({
            id: unit.id,
            label: unit.internalNumber
          });
          return null;
        });
      }
    } catch (e) {
      alert(e);
    }
    this.setState({ options: options, isLoading: false });
  }
  
  getTags() {
    return invokeApig({
      path: "/tag/find",
      method: "POST",
      body: {
        "page": 0,
        "size": 10
      }
    });
  }

  async showTags() {
	const options = [];
	try {
      this.setState({ options: [] });
      const result = await this.getTags();
      if (result && result.Items) {
        result.Items.map((tag) => {
          options.push({
            id: tag,
            label: tag
          });
          return null;
        });
      }
    } catch (e) {
      alert(e);
    }
    this.setState({ isLoading: false, options: options });
  }

  handleTypeChange = (value) => {
    var option = value.length ? value[0].id : '';
    var last = value[value.length - 1];
    switch(option) {
      case 'UNIT':
      if (value.length === 1) {
        this.showUnits();
        this.setState({ value, type: option });
      } else {
        let units = this.state.units;
        units.push({
          id: last.id,
          internalNumber: last.label
        });
        this.setState({ value, units });
      }
      break;
      case 'TAG':
      if (value.length === 1) {
        this.showTags();
        this.setState({ value, type: option });
      } else {
        let tags = this.state.tags;
        tags.push(last.id);
        this.setState({ value, tags });
      }
      break;
      case 'ALL':
        this.setState({ value, type: option, options: [], units: [], tags: [] });
      break;
      default:
      this.setState({ value: '', type: undefined, options: this.typeOptions, units: [], tags: [] });
      break;
    }
  }

  handleNewScalation = () => {
    let alertScalations = this.state.alertScalations;
    alertScalations.push({
      level: 1,
      time: null,
      emails: '',
      emailType: 'TO',
      confirmed: false
    });
    this.setState(alertScalations);
  }

  handleScalationConfirm = scalation => {
    let alertScalations = this.state.alertScalations;
    alertScalations.splice(scalation.index, 1, scalation);
    let escalations = this.state.escalations;
    escalations.push({
      level: scalation.level,
      time: scalation.time,
      emails: scalation.emails,
      emailType: scalation.emailType
    });
    this.setState({alertScalations, escalations});
  }

  handleScalationRemove = scalation => {
    new Promise((resolve) => {
      let alertScalations = this.state.alertScalations;
      let deleted = alertScalations.splice(scalation.index, 1);
      resolve(alertScalations);
    }).then((alertScalations) => {
      let escalations = [];
      alertScalations.array.forEach(alertScalation => {
        if (alertScalation.confirmed) {
          escalations.push({
            level: scalation.level,
            time: scalation.time,
            emails: scalation.emails,
            emailType: scalation.emailType
          });
        }
      });
      this.setState({alertScalations, escalations});
    });
  }

  renderFormNew(){
    const { disabled, stayOpen, value, options, alertOptions } = this.state;
    return(
	  <Form horizontal onSubmit={this.handleSubmit}>
      <FormGroup controlId="nameAlert">
        <Col componentClass={ControlLabel} sm={3}>
          Nombre{' '}
          <OverlayTrigger overlay={<Tooltip id="modal-tooltip">Corresponde al tipo de alerta.</Tooltip>}>
            <a tabIndex="-1"><Glyphicon glyph="info-sign"/></a>
          </OverlayTrigger>
        </Col>
        <Col sm={9}>
          <FormControl componentClass="select" onChange={this.handleAlertChange} value={this.state.alert} >
            {
              alertOptions.map((type, i) => 
                <option key={type.id} value={type.id}>{type.label}</option>
              )
            }
          </FormControl>
        </Col>
      </FormGroup>
      <FormGroup controlId="description">
        <Col componentClass={ControlLabel} sm={3}>
          Descripción{' '}
          <OverlayTrigger overlay={<Tooltip id="modal-tooltip">Corresponde a la descripción de la alerta.</Tooltip>}>
            <a tabIndex="-1"><Glyphicon glyph="info-sign"/></a>
          </OverlayTrigger>
        </Col>
        <Col sm={9}>
          <FormControl
          onChange={this.handleChange}
          value={this.state.description}
          placeholder="Ingrese solo texto"
        />
        </Col>
      </FormGroup>
      <FormGroup controlId="semaphore">
        <Col componentClass={ControlLabel} sm={3}>
        Semáforo{' '}
          <OverlayTrigger overlay={<Tooltip id="modal-tooltip">Corresponde al semáforo de alerta.</Tooltip>}>
            <a tabIndex="-1"><Glyphicon glyph="info-sign"/></a>
          </OverlayTrigger>
        </Col>
        <Col sm={9}>
          <ToggleButtonGroup
            type="radio"
            name="semaphores"
            value={this.state.semaphore}
            onChange={this.handleSemaphoreChange}
          >
            <ToggleButton bsStyle="danger" value={"red"}>Rojo (grave)</ToggleButton>
            <ToggleButton bsStyle="warning" value={"yellow"}>Amarillo (medio)</ToggleButton>
            <ToggleButton bsStyle="success" value={"green"}>Verde (bajo)</ToggleButton>
          </ToggleButtonGroup>
        </Col>
      </FormGroup>
      <FormGroup controlId="type">
        <Col componentClass={ControlLabel} sm={3}>
          Vehículos{' '}
          <OverlayTrigger overlay={<Tooltip id="modal-tooltip">Corresponde a los vehículos asociados a la alerta.</Tooltip>}>
            <a tabIndex="-1"><Glyphicon glyph="info-sign"/></a>
          </OverlayTrigger>
        </Col>
        <Col sm={9}>
          <Select
            closeOnSelect={!stayOpen}
            disabled={disabled}
            multi={true}
            onChange={this.handleTypeChange}
            options={options}
            placeholder="Click para ver opciones"
            removeSelected={this.state.removeSelected}
            valueKey="id"
            labelKey="label"
            value={value}
              />
        </Col>
      </FormGroup>
      <FormGroup>
        <Col componentClass={ControlLabel} sm={3}>
          Escalar A{' '}
          <OverlayTrigger overlay={<Tooltip id="modal-tooltip">Corresponde a los escalamientos de la alerta.</Tooltip>}>
            <a tabIndex="-1"><Glyphicon glyph="info-sign"/></a>
          </OverlayTrigger>
        </Col>
        <Col sm={9}>
        <Panel>
          <Table>
            <thead>
              <tr>
                <th width="20%">Nivel</th>
                <th width="20%">Tiempo</th>
                <th width="70%">Emails</th>
                <th width="10%">
                  <Button bsSize="xsmall" onClick={this.handleNewScalation}>
                    <Glyphicon glyph="plus" />
                  </Button>
                </th>
              </tr>
            </thead>
          </Table>
          <div id="scalations">
            {
              this.state.alertScalations.map((scalation, index) => {
                scalation.index = index;
                return <AlertScalation {...scalation} key={index} onConfirm={this.handleScalationConfirm} onRemove={this.handleScalationRemove}></AlertScalation>
              })
            }
          </div>
        </Panel>
        </Col>
      </FormGroup>
      <LoaderButton
            block
            bsStyle="primary"
            bsSize="large"
            type="submit"
            isLoading={this.state.isLoading}
            text={this.state.isEdit ? "Modificar" : "Crear" }
            loadingText="Guardando…"
          />
      </Form>
    );
  }

  render() {
  const tooltipEdit = (<Tooltip id="tooltipEdit"><strong>Modificar</strong></Tooltip>);
    return (
      <div>
        {
          this.state.isEdit ? 
            <OverlayTrigger placement="top" overlay={tooltipEdit}>
              <Button onClick={this.handleEdit}><Glyphicon glyph="edit"/></Button>
            </OverlayTrigger> 
          :
      		  <Button bsStyle="primary" onClick={this.handleShow}><Glyphicon glyph="user" />Crear Alerta</Button>
      	}
        <Modal show={this.state.show} onHide={this.handleClose}>
          <Modal.Header closeButton>
            <Modal.Title>Datos de la Alerta</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            {this.renderFormNew()}
          </Modal.Body>
          <Modal.Footer>
            <Button onClick={this.handleClose}>Cerrar</Button>
          </Modal.Footer>
        </Modal>
      </div>
    );
  }
}

export default NewAlert


// WEBPACK FOOTER //
// ./src/containers/alert/NewAlert.js